"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledContainer = exports.ChartNeedsOptions = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var ChartNeedsOptions = _styledComponents["default"].h4.withConfig({
  displayName: "styles__ChartNeedsOptions",
  componentId: "sc-1cvc7a8-0"
})(["position:absolute;top:50%;left:50%;transform:translate(-57%,-50%);color:#bdbdbd;"]);

exports.ChartNeedsOptions = ChartNeedsOptions;

var StyledContainer = _styledComponents["default"].div.withConfig({
  displayName: "styles__StyledContainer",
  componentId: "sc-1cvc7a8-1"
})(["", " ", " ", " .c-chart{display:flex;flex-direction:column;width:100%;height:100%;background-position:50%;background-size:cover;.vega-bindings{flex-shrink:0;.vega-bind{display:block;margin-top:10px;font-size:14px;label{display:flex;justify-content:start;align-items:center;span{display:inline-block;&:first-of-type{min-width:140px;margin-right:10px;}&:last-of-type:not(:first-of-type){margin-left:10px;}}}}}", " ", "}"], function (props) {
  return !props.standalone && (0, _styledComponents.css)(["position:relative;flex-grow:1;flex:1;padding:20px 20px 55px 50px;width:100%;box-sizing:border-box;"]);
}, function (props) {
  return (props.standalone || props.thumbnail) && (0, _styledComponents.css)(["width:100%;height:auto;"]);
}, function (props) {
  return props.compact && (0, _styledComponents.css)(["padding-bottom:50px;"]);
}, function (props) {
  return !props.standalone && (0, _styledComponents.css)(["max-height:400px;"]);
}, function (props) {
  return props.compact && (0, _styledComponents.css)(["height:400px;"]);
});

exports.StyledContainer = StyledContainer;